
import { Panel } from "primereact/panel";
import { TextField } from "../../../components/TextField";
import { formatarCNPJ, formatarCPF, formatarParaMoedaBRL } from "../../../utils";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useTranslation } from "react-i18next";
 
 
 
export const BacenScoreSCRAnalitico = (data: any) => {
  const cadastral = data?.soapEnvelope.soapBody.ns2getResumoDoClienteResponse.return ?? null;
  const { t } = useTranslation(); 

  const getValue = (value?: string): string => value || "Não informado";

  const getPrazo = (item:any) => {
    if(item.codigoVencimento === 'v20'){
      return 'Limite de crédito com vencimento até 360 dias';
    }
    if(item.codigoVencimento === 'v40'){
      return 'Limite de crédito com vencimento acima de 360 dias';
    }
    if(item.codigoVencimento === 'v110'){
      return 'Créditos a vencer até 30 dias';
    }
    if(item.codigoVencimento === 'v120'){
      return 'Créditos a vencer de 31 a 60 dias';
    }
    if(item.codigoVencimento === 'v130'){
      return 'Créditos a vencer de 61 a 90 dias';
    }
    if(item.codigoVencimento === 'v140'){
      return 'Créditos a vencer de 91 a 180 dias';
    }
    if(item.codigoVencimento === 'v150'){
      return 'Créditos a vencer de 181 a 360 dias';
    }
    if(item.codigoVencimento === 'v160'){
      return 'Créditos a vencer de 361 a 720 dias';
    }
    if(item.codigoVencimento === 'v165'){
      return 'Créditos a vencer de 721 a 1080 dias';
    }
    if(item.codigoVencimento === 'v170'){
      return 'Créditos a vencer de 1081 a 1440 dias';
    }
    if(item.codigoVencimento === 'v175'){
      return 'Créditos a vencer de 1441 a 1800 dias';
    }
    if(item.codigoVencimento === 'v180'){
      return 'Créditos a vencer de 1801 a 5400 dias';
    }


    
    return item.codigoVencimento;
  }; 

  
 
  return (
    <div>
      <Panel header="Dado Comportamental de Pagamento Analítico">
        <Panel header="Identificação">
          <section style={{ display: "grid", gridTemplateColumns: "1fr 1fr" }}>
            <div>
              <TextField
                label="Documento"
                value={getValue(cadastral?.codigoDoCliente.length === 11 ? formatarCPF(cadastral?.codigoDoCliente) : formatarCNPJ(cadastral?.codigoDoCliente))}
              />
             <TextField
                label="Instituições Financeiras"
                value={getValue(cadastral?.quantidadeDeInstituicoes)}
              />
            
              <TextField
                label="Percentual documentos processados"
                value={getValue(cadastral?.percentualDocumentosProcessados)}
              />
              <TextField
                label="Quantidade operações"
                value={getValue(cadastral?.quantidadeDeOperacoes)}
              />
            </div>
            <div>
              <TextField
                label="Data de início de relacionamento"
                value={getValue(cadastral && cadastral.dataInicioRelacionamento ? (cadastral.dataInicioRelacionamento.substring(8) + '/' +  cadastral.dataInicioRelacionamento.substring(5,7) + '/' + cadastral.dataInicioRelacionamento.substring(0,4)): undefined)}
              />
              <TextField
                label="Data Base"
                value={getValue(
                  cadastral?.dataBaseConsultada ? cadastral?.dataBaseConsultada.split('-')[1] + '/' + cadastral?.dataBaseConsultada.split('-')[0] : undefined
                )}
              />
              <TextField
                label="Percentual Processamento Valor"
                value={getValue(cadastral?.percentualVolumeProcessado)}
              />
              <TextField
                label="Quantidade operações subjudice"
                value={cadastral?.quantidadeOperacoesSubJudice}
              />
            </div>
          </section>
        </Panel>
        <br />
        {cadastral.listaDeResumoDasOperacoes.map((item:any, index:number) => (
          <div key={'div_' + index}>
            <Panel key={'panel_' + index} header={'Modalidade - ' + item.modalidade}>
               <DataTable size="small" value={item.listaDeVencimentos.sort( (a:any,b:any) => {
      {
        if(!a.codigoVencimento){
          return 1;
        }

        if(!b.codigoVencimento){
          return -1;
        }

        if (a.codigoVencimento > b.codigoVencimento) {
          return 1;
        }
        if (a.codigoVencimento < b.codigoVencimento) {
          return -1;
        }
        return 0;
      }
    } )} tableStyle={{ minWidth: '50rem' }}>
                  <Column body={getPrazo} header={t('prazo')}></Column>
                  <Column body={(item) => formatarParaMoedaBRL(item.valorVencimento)} header={t('valor')}></Column>
                </DataTable>
            </Panel>
           <br></br>
          </div>
        ))}
 
         
      </Panel>
    </div>
  );
};